// extracted by mini-css-extract-plugin
export default {"ldshourglass":"Spinner_ldshourglass__mTev6","lds-hourglass":"Spinner_lds-hourglass__CJ02W"};